import React from "react";
import { Col } from "react-bootstrap";
import GeneralMetricsWidget from "./Widgets/GeneralMetricsWidget";
import WeeklySalesChartWidget from "./Widgets/WeeklySalesChartWidget";
import RegionSalesChartWidget from "./Widgets/RegionSalesChartWidget";

export default function ProductLineTabContent(props) {
  return (
    <div className="dashboard-boxes-container">
      <Col md={10} mdPush={1}>
        <GeneralMetricsWidget
          productLineAnalytics={props.productLineAnalytics}
        />
      </Col>

      <Col md={10} mdPush={1}>
        <WeeklySalesChartWidget
          productLineAnalytics={props.productLineAnalytics}
        />
        <br />
        <RegionSalesChartWidget
          productLineAnalytics={props.productLineAnalytics}
        />
        <br />
        <br />
      </Col>
      {/*
        We are now hiding the Feedback Widget in the Dashboard
        Trello Card: https://trello.com/c/cCcyhowe/376-merchant-reminder-for-a-better-conversion-samples-to-orders-ii

        <Col md={3} mdPush={1}>
          <FeedbackWidget productLineAnalytics={props.productLineAnalytics} />
        </Col>
        */}
    </div>
  );
}
